var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiomarkers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11859_34899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.32 18.1918C11.71 18.5418 12.3 18.5418 12.69 18.1918C14.65 16.4318 15 14.1518 15 12.9918C15 11.8418 14.65 9.5518 12.68 7.7918C12.29 7.4418 11.7 7.4418 11.31 7.7918C9.35 9.5518 9 11.8318 9 12.9918C9 14.1418 9.35 16.4318 11.32 18.1918Z",
    fill: "#5572CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4987 12.9922C16.4987 13.9622 16.2687 17.1522 13.4688 19.4922C14.2487 19.8022 15.0987 19.9922 15.9987 19.9922C19.8587 19.9922 22.9987 16.8522 22.9987 12.9922C22.9987 9.13219 19.8587 5.99219 15.9987 5.99219C15.0987 5.99219 14.2487 6.18219 13.4688 6.49219C16.2687 8.83219 16.4987 12.0222 16.4987 12.9922Z",
    fill: "#5572CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 19.9922C8.9 19.9922 9.75 19.8022 10.53 19.4922C9.92 18.9822 9.43 18.4222 9.04 17.8622C8.71 17.9422 8.36 17.9922 8 17.9922C5.24 17.9922 3 15.7522 3 12.9922C3 10.2322 5.24 7.99219 8 7.99219C8.36 7.99219 8.71 8.04219 9.04 8.12219C9.43 7.56219 9.92 7.00219 10.53 6.49219C9.75 6.18219 8.9 5.99219 8 5.99219C4.14 5.99219 1 9.13219 1 12.9922C1 16.8522 4.14 19.9922 8 19.9922Z",
    fill: "#5572CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11859_34899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.992188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiomarkers);
export default __webpack_public_path__ + "static/media/biomarkers.3c263a9050bc5b869389e91ff7545d5d.svg";
export { ForwardRef as ReactComponent };